class BaseCalculator {
  constructor(formulas) {
    this.formulas = formulas;

    this.values = {
      target: null,
      training: null,
      activity: null,
      weight: null,
      size: null,
      age: null,
      gender: null,
      sleep: null
    };
  }

  setTarget(target) {
    this.values.target = target;
  }

  setTraining(training) {
    this.values.training = training;
  }

  setActivity(activity) {
    this.values.activity = activity;
  }

  setWeight(weight) {
    this.values.weight = weight;
  }

  setSize(size) {
    this.values.size = size;
  }

  setAge(age) {
    this.values.age = age;
  }

  setGender(gender) {
    this.values.gender = gender;
  }

  setSleep(sleep) {
    this.values.sleep = sleep;
  }

  getTarget() {
    return this.values.target;
  }

  getTraining() {
    return this.values.training;
  }

  getActivity() {
    return this.values.activity;
  }

  getWeight() {
    return this.values.weight;
  }

  getSize() {
    return this.values.size;
  }

  getAge() {
    return this.values.age;
  }

  getGender() {
    return this.values.gender;
  }

  getSleep() {
    return this.values.sleep;
  }

  getValueByTarget(target) {
    return this.values[target] ?? null;
  }

  getFormularByType(type) {
    return this.formulas.find((formular) => formular.type == type);
  }

  getBasicVolume() {
    const gender = this.getGender();
    const weight = this.getWeight();
    const size = this.getSize();
    const age = this.getAge();

    const FORMULAS = {
      1: () => 655.1 + (9.6 * weight) + (1.8 * size) - (4.7 * age),
      2: () => 66.47 + (13.7 * weight) + (5 * size) - (6.8 * age)
    };

    return FORMULAS[gender]?.() || 0;
  }

  getKcalTarget() {
    return this.kcalTargetFactor?.[this.values.target];
  }

  getResult() {
    return {
      ...this.result,
      target: this.values.target
    };
  }

  pageValid(page) {
    return page.inputs.every((input) => {
      const value = this.getValueByTarget(input.target);
      return value !== null && value !== "";
    });
  }

  _prepareFormular(formular) {
    const replacements = {
      '[[RESULT_KCAL]]': this.result.kcal,
      '[[RESULT_PROTEIN]]': this.result.protein,
      '[[RESULT_FAT]]': this.result.fat,
      '[[TARGET]]': this.values.target,
      '[[WEIGHT]]': this.values.weight,
      '[[SIZE]]': this.values.size,
      '[[AGE]]': this.values.age,
      '[[ACTIVITY]]': this.values.activity,
      '[[SLEEP]]': this.values.sleep
    };

    return Object.entries(replacements).reduce(
      (formula, [placeholder, value]) => formula.replaceAll(placeholder, value),
      formular
    );
  }
  
  _debug() {
    const isValid = (value) => value !== null && value !== "";
    const { target, training, activity, size, age, gender, weight, sleep } = this.values;

    console.table({
      target,
      kcaltarget: this.kcalTargetFactor?.[target],
      fatTargetFactor: this.fatTargetFactor?.[target],
      proteinTargetFactor: this.proteinTargetFactor?.[target],
      training,
      activity,
      size,
      age,
      gender,
      weight,
      sleep,
      valid: Object.values(this.values).every(isValid),
      target_valid: isValid(target),
      training_valid: isValid(training),
      activity_valid: isValid(activity),
      weight_valid: isValid(weight),
      size_valid: isValid(size),
      age_valid: isValid(age),
      gender_valid: isValid(gender),
      sleep_valid: isValid(sleep)
    });
  }
}
